module.exports = __webpack_public_path__ + "img/PEYTO_III.b0837be2.png";